import { PkButton, PkIcon, PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';
import { competitionUrl } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const MomentsIdentifier = () => {
  const t = useTranslateFn();
  const { isMobile } = useWindowSize();
  const directToMomentsLink = () => `/${competitionUrl}/video/moments/`;

  return (
    <PkIdentifier className={clsx(styles.momentsIdentifier, 'pk-theme--light pk-pb-lg--l pk-pb--m')} alignment='left'>
      <span slot='primary'>{t('moments')}</span>
      <span slot='suffix'>
        <PkButton appearance='text' type='button' link-href={directToMomentsLink()}>
          {isMobile ? t('see_all') : t('see_all_moments')}
          <PkIcon name='navigation-chevron-right' title={t('moments')} />
        </PkButton>
      </span>
    </PkIdentifier>
  );
};

export default memo(MomentsIdentifier);
